import { EntityIcon } from '..';
import { TProps } from '../types/TProps';

const xlSizeClassName =
  'h-20 w-20 bg-[var(--color-avatar-bg)] text-[36px] leading-[130%] text-[var(--color-on-surface)]';

export const EntityIconXl = ({ className, sizeClassName, ...props }: TProps) => (
  <EntityIcon {...props} sizeClassName={sizeClassName ?? xlSizeClassName} className={className} />
);
